import { Injectable } from '@angular/core';

@Injectable()
export class HomeService {
  /** Service constructor */
  constructor() {}
}
